import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import parseZone from "@trainline-shareable/dayjs-plugins/plugin/parseZone";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(parseZone);
dayjs.extend(customParseFormat);
const setZeroTimezoneOffset = (date) => {
  const parsedDate = dayjs.parseZone(date);
  return parsedDate.isValid() ? `${parsedDate.format("YYYY-MM-DDTHH:mm:ss")}+00:00` : date;
};
var setZeroTimezoneOffset_default = setZeroTimezoneOffset;
export {
  setZeroTimezoneOffset_default as default
};
